const AccountSettings = () => {
    return (
        <div className="flex flex-col p-6">
            <div className="mb-6">
                <p className="text-2xl text-[#EEEEEE] font-medium">Organisation Details</p>
            </div>
            <div className="flex gap-2">
            <p className="text-[#EEEEEE] text-lg font-bold">Email: </p>
            <p className="text-[#EEEEEE] font-light text-lg">demo.vecros@gmail.com</p>
            </div>
        </div>
    )
}

export default AccountSettings